export const calculateDistribution = (field, model) => {
  const vision = +model.get('distribution_vision');
  const operations = +model.get('distribution_operations');
  const customer = +model.get('distribution_customer');

  const sum = vision + operations + customer;
  return +model.get(`distribution_${field}`) / sum;
};
